import React from "react";

import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

import ef1 from "../../images/EF/EF1.png";
import ef2 from "../../images/EF/EF2.png";
import ef3 from "../../images/EF/EF3.png";
import ef4 from "../../images/EF/EF4.png";
import ef5 from "../../images/EF/EF5.png";
import ef6 from "../../images/EF/EF6.png";

const Exclusivefeatures = () => {
  return (
    <div className="QL__PG__Sec__EF">
      <Container>
        
          <h1 className="HeadingAll">Exclusive Features</h1>
          <p>
          We go an extra mile to bring a flawless setup for our students. 
            <br />Each feature is designed to enhance convenience for our valuable clients.
          </p>
          <br />
          <br />
      
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} sm={6} md={4} textAlign="center">
            <Card
              className="QL__EF__cards"
              sx={{ minWidth: 275 }}
              justifyContent="center"
            >
              <CardContent>
                <Typography
                  sx={{ fontSize: 14 }}
                  color="text.secondary"
                  gutterBottom
                >
                  <img className="QL__EF__IMGS" src={ef1} alt="image"/>
                </Typography>
                <Typography
                  sx={{ mb: 2 }}
                  variant="h3"
                  justifyContent="center"
                  fontWeight={600}
                >
                  zoom
                </Typography>
                <Typography variant="h5" fontWeight={600}>
                  Instant Access
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={4} textAlign="center">
            <Card
              className="QL__EF__cards"
              sx={{ minWidth: 275 }}
              justifyContent="center"
            >
              <CardContent>
                <Typography
                  sx={{ fontSize: 14 }}
                  color="text.secondary"
                  gutterBottom
                >
                  <img className="QL__EF__IMGS2" src={ef2} alt="image"/>
                </Typography>
                <br />
                <Typography variant="h5" fontWeight={600}>
                  Safe Atmosphere
                  <br />
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={4} textAlign="center">
            <Card
              className="QL__EF__cards"
              sx={{ minWidth: 275 }}
              justifyContent="center"
            >
              <CardContent>
                <Typography
                  sx={{ fontSize: 14 }}
                  color="text.secondary"
                  gutterBottom
                >
                  <img className="QL__EF__IMGS3" src={ef3} alt="image"/>
                </Typography>

                <br />

                <Typography variant="h5" fontWeight={600}>
                  Female Tutors
                  <br />
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={4} textAlign="center">
            <Card
              className="QL__EF__cards"
              sx={{ minWidth: 275 }}
              justifyContent="center"
            >
              <CardContent>
                <Typography
                  sx={{ fontSize: 14 }}
                  color="text.secondary"
                  gutterBottom
                >
                  <img className="QL__EF__IMGS3" src={ef4} alt="image"/>
                </Typography>

                <br />

                <Typography variant="h5" fontWeight={600}>
                  Flexible Timings
                  <br />
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={4} textAlign="center">
            <Card
              className="QL__EF__cards"
              sx={{ minWidth: 275 }}
              justifyContent="center"
            >
              <CardContent>
                <Typography
                  sx={{ fontSize: 14 }}
                  color="text.secondary"
                  gutterBottom
                >
                  <img className="QL__EF__IMGS3" src={ef5} alt="image"/>
                </Typography>

                <br />

                <Typography variant="h5" fontWeight={600}>
                  Weekend Classes
                  <br />
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={4} textAlign="center">
            <Card
              className="QL__EF__cards"
              sx={{ minWidth: 275 }}
              justifyContent="center"
            >
              <CardContent>
                <Typography
                  sx={{ fontSize: 14 }}
                  color="text.secondary"
                  gutterBottom
                >
                  <img className="QL__EF__IMGS3" src={ef6} alt="image"/>
                </Typography>
                <br />
                <Typography variant="h5" fontWeight={600}>
                  Parental Control
                  <br />
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default Exclusivefeatures;
